import { MenuItem } from '../models/menu/menu.model';
import { ROUTE_IDENTIFIER_NAMES } from '../models/route-identifiers/route-identifiers.model';
import { SECURITY_ROLE_KEY } from '../models/security/security-role-keys';

export const menuItems: MenuItem[] = [
  {
    label: 'Home',
    icon: 'home',
    route: '/home',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.HOME,
    securityRoles: SECURITY_ROLE_KEY.User,
  },
  {
    label: 'My details',
    route: '/person/details',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.MY_USER_PROFILE,
    securityRoles: SECURITY_ROLE_KEY.User,
    hideItem: true,
  },
  {
    label: 'My competencies',
    icon: 'my_competency',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_CLAIMS,
    securityRoles: SECURITY_ROLE_KEY.User,
    subMenu: [
      {
        label: 'Create new assessment',
        route: '/claims/new',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.NEW,
      },
      {
        label: 'Draft assessments',
        route: '/claims/claimant/draft',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.DRAFT,
      },
      {
        label: 'Pending assessment',
        route: '/claims/claimant/withAssessor',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.WITH_ASSESSOR,
      },
      {
        label: 'Requiring information',
        route: '/claims/claimant/actionRequired',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ACTION_REQUIRED,
      },
      {
        label: 'Published competencies',
        route: '/claims/claimant/published',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.PUBLISHED,
      },
      {
        label: 'All assessments',
        route: '/claims/claimant/all',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ALL_CLAIMS,
      },
    ],
  },
  {
    label: 'My assessments',
    icon: 'assessment',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.COMPETENCY_ASSESSMENTS,
    securityRoles: SECURITY_ROLE_KEY.Assessor,
    forAssessorOnly: true,
    subMenu: [
      {
        label: 'Pending assessment',
        route: '/claims/assessor/actionRequired',
        securityRoles: SECURITY_ROLE_KEY.Assessor,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ASSESSOR_ACTION_REQUIRED,
        claimCategory: 'VERIFIED',
      },
      {
        label: 'Assessed by me',
        route: '/claims/assessor/published',
        securityRoles: SECURITY_ROLE_KEY.Assessor,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ASSESSOR_PUBLISHED,
        claimCategory: 'VERIFY',
      },
      {
        label: 'All assessments',
        route: '/claims/assessor/all',
        securityRoles: SECURITY_ROLE_KEY.Assessor,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ASSESSOR_ALL,
        claimCategory: 'ALL_ASSESSMENTS',
      },
    ],
  },
  {
    label: 'Development actions',
    icon: 'design_services',
    route: '/development-actions',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.MY_DEVELOPMENT_ACTIONS,
    securityRoles: SECURITY_ROLE_KEY.User,
  },
  {
    label: 'Training events',
    icon: 'calendar',
    securityRoles: SECURITY_ROLE_KEY.User,
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.EVENTS_CALENDAR,
    subMenu: [
      {
        label: 'Events calendar',
        itemTranslationKey: 'trainingCalendar',
        route: '/events/calendar',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.TRAINING_CALENDAR,
      },
      {
        label: 'Assessment settings',
        itemTranslationKey: 'trainingCalendarSettings',
        route: '/events/training-assessment-settings',
        securityRoles: [
          SECURITY_ROLE_KEY.SessionAdmin,
          SECURITY_ROLE_KEY.Admin,
          SECURITY_ROLE_KEY.Superuser,
        ],
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.TRAINING_CALENDAR_SETTINGS,
      },
    ],
  },
  {
    label: 'Matrices',
    icon: 'grid',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.MATRICES,
    securityRoles: SECURITY_ROLE_KEY.User,
    subMenu: [
      {
        label: 'Training matrix',
        route: '/matrices/training-matrix',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS_TRAINING_MATRIX,
      },
      {
        label: 'Competency matrix',
        route: '/matrices/competency-matrix',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS_COMPETENCY_MATRIX,
      },
    ],
  },
  {
    label: 'Analytics',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS,
    icon: 'analytics',
    securityRoles: SECURITY_ROLE_KEY.User,
    subMenu: [
      {
        label: 'Job role profile',
        route: '/job-role/my-job-role-profile',
        securityRoles: SECURITY_ROLE_KEY.User,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.MY_JOB_ROLE_PROFILE,
      },
      {
        label: 'Job role analysis',
        route: '/job-role/job-role-analysis',
        securityRoles: SECURITY_ROLE_KEY.OuResponsible,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ANALYSIS_JOB_ROLES,
      },
      {
        label: `Competency & training analytics`,
        route: '/matrices/competency-training-analytics',
        securityRoles: SECURITY_ROLE_KEY.SessionAdmin,
        routeIdentifier:
          ROUTE_IDENTIFIER_NAMES.ANALYSIS_COMPETENCY_TRAINING_ANALYTICS,
      },
      {
        label: 'Training matrix summary',
        route: '/matrices/training-matrix-summary',
        securityRoles: SECURITY_ROLE_KEY.OuResponsible,
        routeIdentifier:
          ROUTE_IDENTIFIER_NAMES.ANALYSIS_TRAINING_MATRIX_SUMMARY,
      },
    ],
  },
  {
    label: 'Training management',
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.LMS,
    icon: 'school',
    securityRoles: SECURITY_ROLE_KEY.Superuser,
    hideItem: true,
    subMenu: [
      {
        label: 'Training providers',
        route: '/training-management/training-providers',
        securityRoles: SECURITY_ROLE_KEY.Superuser,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.LMS_VIEW_PROVIDERS,
      },
    ],
  },
  {
    label: 'Admin',
    icon: 'admin',
    securityRoles: SECURITY_ROLE_KEY.JobRolePeople,
    routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN,
    subMenu: [
      {
        label: 'Assessment checklists',
        route: '/assessment-checklists/checklists',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_OBSERVATION_CHECKLISTS,
        hideItem: false,
      },
      {
        label: 'Assessment library',
        route: '/assessment-library',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_QUESTION_LISTVIEW,
        hideItem: false,
      },
      {
        label: 'Capability framework',
        route: '/capability-framework',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_CAPABILITY_FRAMEWORK,
      },
      {
        label: 'Capability passports',
        route: '/capability-passport/passport-list',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_CAPABILITY_PASSPORT,
      },
      {
        label: 'Competency library',
        route: '/competency-library',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_COMPETENCY_LIBRARY,
      },
      {
        label: 'Group management',
        route: '/group-management/groups-list',
        securityRoles: [
          SECURITY_ROLE_KEY.JobRolePeople,
          SECURITY_ROLE_KEY.JobRoleReqs,
          SECURITY_ROLE_KEY.JobRoleReqsPeople,
          SECURITY_ROLE_KEY.Admin,
          SECURITY_ROLE_KEY.Superuser,
        ],
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_JOB_ROLE_GROUPS,
        readOnly: [SECURITY_ROLE_KEY.JobRoleReqs],
      },
      {
        label: 'Level group library',
        route: '/level-group-library',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_LEVEL_GROUP_LIBRARY,
      },
      {
        label: 'Matrix settings',
        route: '/matrices/matrix-settings',
        securityRoles: SECURITY_ROLE_KEY.OuResponsible,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_MATRIX_SETTINGS,
        readOnly: [SECURITY_ROLE_KEY.OuResponsible],
      },
      {
        label: 'Notification settings',
        route: '/notifications',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_NOTIFICATION_SETTINGS,
        hideItem: true,
      },
      {
        label: 'Role management',
        route: '/role-management/job-roles-list',
        securityRoles: [
          SECURITY_ROLE_KEY.JobRolePeople,
          SECURITY_ROLE_KEY.JobRoleReqs,
          SECURITY_ROLE_KEY.JobRoleReqsPeople,
          SECURITY_ROLE_KEY.Admin,
          SECURITY_ROLE_KEY.Superuser,
        ],
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_JOB_ROLES_LIST,
      },
      {
        label: 'User permissions and roles',
        route: '/person/user-security-roles',
        securityRoles: SECURITY_ROLE_KEY.Admin,
        routeIdentifier: ROUTE_IDENTIFIER_NAMES.ADMIN_USER_SECURITY_ROLES,
      },
    ],
  },
];
